import React from 'react';
import './ProgressBar.scss';

const ProgressBar = ({
  value = 0,
  maxValue = 100,
  barColor = '#6ECA4B',
  trackColor = '#F0F0F0',
  width = '130px',
  height = '6px',
  showBar = true,
}) => {
  const percent = maxValue > 0 ? Math.min((value / maxValue) * 100, 100) : 0;

  return (
    <div
      className="progress-bar-component"
      style={{ width, height, background: trackColor }}
    >
      {showBar && (
        <div
          className="progress-bar-active"
          style={{ width: `${percent}%`, background: barColor }}
        />
      )}
    </div>
  );
};

export default ProgressBar;
